import { PRODUCT_CATEGORY_SOURCE_LABELS } from './productCategories'
import './AiClassifyingLabel.css'

export function AiClassifyingLabel() {
  return <span className="ai-classifying-label">{PRODUCT_CATEGORY_SOURCE_LABELS.PENDING_AI}</span>
}
